import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, CheckIcon, PlusIcon } from 'lucide-react';
import { ServiceIcon } from './ServiceIcon';
import { services } from '../data/services';
import { images, site } from '../data/site';
type ServicesProps = {
  selected: string[];
  onToggle: (id: string) => void;
};
export function Services({
  selected,
  onToggle
}: ServicesProps) {
  return <section id="services" className="bg-canvas py-20 lg:py-28" data-id="element-391" data-mp="13wehznb084nu">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16 lg:px-8" data-id="element-392" data-mp="13xpkzkwml8dw">
        <div className="lg:sticky lg:top-28 lg:self-start" data-id="element-393" data-mp="u61lqxttun1v">
          <h2 className="font-display text-5xl font-extrabold uppercase leading-[0.95] text-ink lg:text-6xl" data-id="element-394" data-mp="u6l42fne3dgf">
            Common everyday <span className="text-brand" data-id="element-395" data-mp="q2n4y4y2e2nd">services</span>
          </h2>
          <p className="mt-5 max-w-md text-lg leading-relaxed text-ink-muted" data-id="element-396" data-mp="l4tzxf8hzeoo">
            Here are just some of the many kinds of issues we handle. Tap <strong className="text-ink" data-id="element-397" data-mp="36chl0as85o0q">Add</strong>{' '}
            on anything you need and we’ll bundle it into one free estimate.
          </p>
          <img src={images.flooring} alt="Technician installing new vinyl plank flooring" className="mt-8 hidden aspect-[4/3] w-full rounded-2xl object-cover lg:block" data-id="element-398" data-mp="3b3zlyyu8zolp" />
          <div className="mt-8 flex flex-wrap items-center gap-x-5 gap-y-3" data-id="element-399" data-mp="32b4cfsxqz6q4">
            <a href="#estimate" className="rounded-lg bg-ink px-6 py-3.5 font-display text-xl font-bold text-white transition-colors duration-150 hover:bg-ink-soft" data-id="element-400" data-mp="3q1i4hjgc15kp">
              {selected.length > 0 ? `Get estimate for ${selected.length} item${selected.length > 1 ? 's' : ''}` : 'Start my estimate'}
            </a>
            <a href={site.phoneHref} className="font-display text-xl font-bold text-brand" data-id="element-401" data-mp="24n43jaeaz68x">
              or call {site.phone}
            </a>
          </div>
        </div>

        <ul className="grid border-t border-line sm:grid-cols-2 sm:gap-x-10" data-id="element-402" data-mp="29k45pa817our">
          {services.map(service => {
          const isSelected = selected.includes(service.id);
          return <li key={service.id} className="flex gap-4 border-b border-line py-6" data-id="element-403" data-mp="1lklnu4stt2jf">
                <span className="grid h-12 w-12 shrink-0 place-items-center rounded-xl bg-white text-brand ring-1 ring-line" data-id="element-404" data-mp="1gpy0485ncc5w">
                  <ServiceIcon name={service.icon} className="h-6 w-6" data-id="element-405" data-mp="16tl5n82a1ua3" />
                </span>
                <div className="flex min-w-0 flex-1 flex-col" data-id="element-406" data-mp="16r8hue9u8pp4">
                  <div className="flex items-center gap-2" data-id="element-407" data-mp="11syjxvwqbazt">
                    <h3 className="font-display text-2xl font-bold leading-tight text-ink" data-id="element-408" data-mp="xsenkujzcbeq">
                      <Link to={`/${service.slug}`} className="transition-colors duration-150 hover:text-brand" data-id="element-409" data-mp="su3fao9c28ym">
                        {service.name}
                      </Link>
                    </h3>
                    {service.popular && <span className="rounded bg-brand-light px-1.5 py-0.5 text-[11px] font-bold text-brand-deep" data-id="element-410" data-mp="2n8e5b01nz95z">
                        Popular
                      </span>}
                  </div>
                  <p className="mt-1 text-[15px] leading-relaxed text-ink-muted" data-id="element-411" data-mp="2zo3zbdi5v43d">{service.blurb}</p>
                  <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-2" data-id="element-412" data-mp="34jjb7zwlypx5">
                  <button type="button" onClick={() => onToggle(service.id)} aria-pressed={isSelected} className={`inline-flex w-fit items-center gap-1.5 rounded-md px-3 py-1.5 text-sm font-bold transition-colors duration-150 ${isSelected ? 'bg-brand text-white hover:bg-brand-dark' : 'bg-white text-ink ring-1 ring-line hover:ring-brand hover:text-brand'}`} data-id="element-413" data-mp="39fgp7zkefk6r">
                    {isSelected ? <>
                        <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-414" data-mp="53whjxjv7qrx" /> Added to estimate
                      </> : <>
                        <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-415" data-mp="3usqsa8502fpb" /> Add to estimate
                      </>}
                  </button>
                  <Link to={`/${service.slug}`} className="inline-flex items-center gap-1 text-sm font-bold text-brand transition-colors duration-150 hover:text-brand-deep" aria-label={`Learn more about ${service.name}`} data-id="element-416" data-mp="8jpuovk7rr4t">
                    Learn more <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-417" data-mp="w8ijm82f4ypx" />
                  </Link>
                  </div>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}